"use client"

import { IdCard } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `IdCardIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const IdCardIcon = component(Icon)({ as: IdCard })
